import { ContentType, Mime } from '../constants/ima'

const mediaElement = document.createElement('video') as HTMLVideoElement

export function detectMimeTypes(): Mime[] {
  let mimes = [Mime.javascript, Mime.mp4]

  if (detectflash()) {
    mimes.push(Mime.flash)
  }

  // Add supported types and de-dup
  mimes = mimes
    .concat(Object.values(Mime).filter(isMimeTypeSupported))
    .filter((mime, pos, self) => self.indexOf(mime) === pos)

  return mimes
}

function detectflash(): boolean {
  if (navigator.plugins && navigator.plugins.length) {
    return navigator.plugins['Shockwave Flash'] && true
  }
  if (navigator.userAgent.toLowerCase().includes('webtv')) {
    return true
  }
  if (
    navigator.appVersion.toLowerCase().includes('msie') &&
    !navigator.userAgent.toLowerCase().includes('opera')
  ) {
    try {
      return new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash') && true
    } catch (e) {
      console.warn('Problem detecting Flash support:', e)
      return false
    }
  }

  return false
}

function isMimeTypeSupported(type: ContentType): boolean {
  if ('MediaSource' in window && window.MediaSource.isTypeSupported(type)) {
    return true
  }

  if (
    'WebKitMediaSource' in window &&
    window.WebKitMediaSource.isTypeSupported(type)
  ) {
    return true
  }

  // IOS Safari does not support `MediaSource` (The only one! Unbelievable!)
  // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource
  if (
    mediaElement.canPlayType &&
    mediaElement.canPlayType(`${type};`).replace(/no/, '')
  ) {
    return true
  }

  return false
}
